import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs';
import { CommonStaffApiServiceService } from '../../common-staff-api-service.service';
import { ToasterService } from '../../../../providers/toaster/toaster.service';
import { LoaderComponent } from "../../../../providers/loader.component";
import { StaffStudentCommonProfileViewComponent } from "../../../../components/personnel-component/staff-student-common-profile-view/staff-student-common-profile-view.component";
import { ClassroomSyllabusCardComponent } from "../../../../components/dashboard-components/classroom-syllabus-card/classroom-syllabus-card.component";

@Component({
  selector: 'app-hod-details',
  standalone: true,
  imports: [StaffStudentCommonProfileViewComponent, LoaderComponent, ClassroomSyllabusCardComponent],
  templateUrl: './hod-details.component.html',
  styleUrl: './hod-details.component.css'
})
export class HodDetailsComponent {
  hodId: number | string | null = null;
  hodData: any = null;
  isFetching: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private staffApiService: CommonStaffApiServiceService,
    private toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.hodId = id;
      if (!id) {
        this.hodData = null;
        return;
      }
      this.fetchHodDetails(id);
    });
  }

  fetchHodDetails(id: number | string) {
    this.isFetching = true;
    this.staffApiService.getStaffProfile(id)
      .pipe(finalize(() => { this.isFetching = false; }))
      .subscribe({
        next: (res: any) => {
          if (res?.status === 'success') {
            this.hodData = res?.data ?? null;
          } else {
            this.hodData = null;
            this.toasterService.setToaster('error', 'Error', res?.message ?? 'Failed to fetch HOD details');
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
          this.hodData = null;
          this.toasterService.setToaster('error', 'Error', 'Failed to fetch HOD details');
        }
      });
  }
}
